// Witcore Suite - Version 1.0.0
// Copyright(c) 2024 Witcore LLC. All rights reserved.

import React from 'react';
import { format } from '../utils/format.js';

const ProgressBar = function ({ value, color }) {
  return (
    <div>
      <div className="progress bg-gray-lighter" style={{ width: 160 }}>
        <div className={'progress-bar bg-' + (color ?? 'blue')} role="progressbar" style={{ width: Math.floor(value * 100) + '%' }} />
      </div>
      <div className="text-muted fs-6 pt-1">
        {format(value, 'percentage')}
      </div>
    </div>
  );
};

export default ProgressBar;